import { Badge } from '@bbpos/ui';
import type { VendorBillStatus } from './types';

type BadgeVariant = 'draft' | 'ordered' | 'partial' | 'success' | 'danger';

const STATUS_MAP: Record<VendorBillStatus, { label: string; variant: BadgeVariant }> = {
  DRAFT: { label: 'Draft', variant: 'draft' },
  OPEN: { label: 'Open', variant: 'ordered' },
  PARTIALLY_PAID: { label: 'Partially paid', variant: 'partial' },
  PAID: { label: 'Paid', variant: 'success' },
  CANCELLED: { label: 'Cancelled', variant: 'danger' },
};

export function VendorBillStatusBadge({ status, size = 'sm' }: { status: VendorBillStatus; size?: 'sm' | 'md' }) {
  const meta = STATUS_MAP[status] ?? STATUS_MAP.OPEN;
  return (
    <Badge variant={meta.variant} size={size}>
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {meta.label}
      </span>
    </Badge>
  );
}
